<template>
    <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.64465 0.366443C7.17084 -0.122148 6.40547 -0.122148 5.93166 0.366443L0.355353 6.11678C-0.118451 6.60537 -0.118451 7.39463 0.355353 7.88322L5.93166 13.6336C6.40547 14.1221 7.17084 14.1221 7.64465 13.6336C8.11845 13.145 8.11845 12.3557 7.64465 11.8671L2.9309 6.99374L7.64465 2.13289C8.11845 1.6443 8.1063 0.842506 7.64465 0.366443Z" fill="currentColor"/>
    </svg>
</template>

<script>
    export default {
        name: "SVGArrowLeft"
    }
</script>

<style scoped>

</style>
